export const numberDecimalFormat = (data) => {
    if (!data) return 0;
    return data.toLocaleString(undefined, {
      minimumFractionDigits: 2,
    });
  };

  function toFixedWithoutRounding(number, decimalPlaces) {
    const power = Math.pow(10, decimalPlaces);
    return (Math.floor(number * power) / power) || 0;
}
export const formatNumber = (num,decimal=2, round=false) => {
  if (!Number(num) || typeof num !== 'number' || isNaN(num)) {
    return 0;
  }
  // Check if the number is in scientific notation
  if (Math.abs(num) < 0.01) {
    let exponent = Math.floor(Math.log10(Math.abs(num)));
    let mantissa = num / Math.pow(10, exponent);
    return <span>{toFixedWithoutRounding(mantissa,decimal)} x 10<sup>{exponent}</sup></span>;
  }

  if(decimal==0){
    let _nim = Math.trunc(num) || 0
    if(round){
      return Math.round(num || 0)?.toLocaleString();
    }
    return _nim?.toLocaleString();
  }
  
    return Number.isInteger(num)? Number(num)?.toLocaleString(): num?.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: decimal });;
}

export const formatUnit = (unit, scriptType = "super", numberToConvert = 2) => {
  // Input validation
  if (!unit || typeof unit !== 'string') {
    return unit || '';
  }

  if (!['super', 'sub'].includes(scriptType)) {
    scriptType = 'super';
  }

  if (![2, 3].includes(numberToConvert)) {
    return unit;
  }

  // Unicode character mappings
  const scriptCharacters = {
    super: {
      2: '\u00B2', // ²
      3: '\u00B3'  // ³
    },
    sub: {
      2: '\u2082', // ₂
      3: '\u2083'  // ₃
    }
  };

  const replacementChar = scriptCharacters[scriptType][numberToConvert];
  return unit.replace(numberToConvert.toString(), replacementChar);
}
  